export default {"src":"/_next/static/media/career hackers.68c2243f.svg","height":69,"width":159,"blurWidth":0,"blurHeight":0};